export default "/img/TN.276f6f88121d1cb98ef27ba655870376.png";